import { Component, createRef } from 'react'
import store from 'store2'
import intlTelInput from 'intl-tel-input'
import get from 'lodash/get'

import PropTypes from 'prop-types'

class PhoneInput extends Component {
  constructor(props) {
    super(props)
    this.inputRef = createRef()
    this.state = {
      value: props.value,
    }
  }

  componentDidUpdate() {
    this.phoneField.setNumber(this.state.value || '')
    /* eslint-disable react/no-did-update-set-state */
    const phone = get(this.props, 'value')
    if(!this.state.value && phone) {
      this.setState({
        value: phone,
      })
    }
  }

  componentDidMount() {
    this.phoneField = intlTelInput(this.inputRef.current, {
      autoPlaceholder: 'off',
      countryOrder: ['us', 'gb', 'de', 'ch'],
      excludeCountries: this.props.countryCode !== 'TW' ? ['tw'] : [],
      formatAsYouType: false,
      geoIpLookup: function(success) {
        success(store.session('diviac.countryCode') || 'US')
      },
      initialCountry: 'auto',
      loadUtils: () => import('intl-tel-input/utils'),
    })

    if(this.props.getPhoneInstance) {
      this.props.getPhoneInstance(this.phoneField, this.props.name)
    }
  }

  changeHandler = (value) => {
    this.setState({
      value,
    })

    this.props.onChange(this.phoneField.getNumber())
  }

  render() {
    return (
      <input
        ref={this.inputRef}
        value={this.state.value}
        placeholder={this.props.placeholder}
        disabled={this.props.disabled}
        onChange={(e) => this.changeHandler(e.target.value)}
        name={this.props.name}
        data-test-id={this.props.testId}
        autoComplete='phone'
      />
    )
  }
}

PhoneInput.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  testId: PropTypes.string,
  getPhoneInstance: PropTypes.func,
  countryCode: PropTypes.string,
}

export default PhoneInput
